import { render, staticRenderFns } from "./SquareCard.vue?vue&type=template&id=686f73f3&"
import script from "./SquareCard.vue?vue&type=script&lang=js&"
export * from "./SquareCard.vue?vue&type=script&lang=js&"
import style0 from "./SquareCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports